import * as React from 'react'
import { cn } from '@claritio/frontend/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        // pointer-coarse:text-base (16px) stops iOS WebKit auto-zooming on focus
        // (any browser on iOS/iPadOS is WebKit); desktop keeps text-sm density (ENG-150).
        'flex h-9 w-full min-w-0 rounded-lg border border-input bg-card px-3 py-1 text-sm pointer-coarse:text-base transition-colors',
        'placeholder:text-muted-foreground file:inline-flex file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
